export default __webpack_public_path__ + "static/media/phoneAndHouse.6dba89f3.svg";